import React, { useState, useEffect } from 'react';
import { ActivityLogService } from '../services/api';

const ActivityLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchLogs = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await ActivityLogService.getAll({ page: currentPage });
      setLogs(response.data.data || response.data);
      if (response.data.last_page) {
        setTotalPages(response.data.last_page);
      }
    } catch (error) {
      console.error("Error fetching activity logs", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(page);
  }, [page]);

  const getActionBadge = (action) => {
    switch (action) {
      case 'created': return <span className="badge bg-success-subtle text-success">Created</span>;
      case 'updated': return <span className="badge bg-info-subtle text-info">Updated</span>;
      case 'deleted': return <span className="badge bg-danger-subtle text-danger">Deleted</span>;
      default: return <span className="badge bg-secondary-subtle text-secondary">{action}</span>;
    }
  };

  return (
    <div className="container-fluid p-0">
      <div className="section-header mb-4">
        <h2 className="fw-bold">Activity Logs</h2>
        <p className="text-muted">Track all actions performed by staff and administrators.</p>
      </div>

      <div className="card-box shadow-sm border">
        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle mb-0">
            <thead className="bg-light">
              <tr>
                <th>Date & Time</th>
                <th>User</th>
                <th>Action</th>
                <th>Description</th>
                <th>Entity Type</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="5" className="text-center py-5 text-muted">Loading logs...</td></tr>
              ) : logs.length > 0 ? (
                logs.map((log) => (
                  <tr key={log.id}>
                    <td>
                      <div className="fw-bold">{new Date(log.created_at).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })}</div>
                      <small className="text-muted">{new Date(log.created_at).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}</small>
                    </td>
                    <td>
                      {log.user ? (
                        <div>
                          <div className="fw-bold">{log.user.name}</div>
                          <small className="text-muted">{log.user.email}</small>
                        </div>
                      ) : (
                        <span className="text-muted">System/Unknown</span>
                      )}
                    </td>
                    <td>{getActionBadge(log.action)}</td>
                    <td>{log.description}</td>
                    <td><span className="badge bg-light text-dark border">{log.model_type}</span></td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5" className="text-center py-5 text-muted">No activity logs found.</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-3">
            <span className="text-muted small">
              Page {page} of {totalPages}
            </span>
            <div className="btn-group">
              <button 
                className="btn btn-sm btn-outline-secondary" 
                onClick={() => setPage(p => Math.max(1, p - 1))}
                disabled={page === 1 || loading}
              >
                Previous
              </button>
              <button 
                className="btn btn-sm btn-outline-secondary" 
                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                disabled={page === totalPages || loading}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityLogs;
